export class InfectedExcludePath {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "SecurityScanExclusionPathType",
            "format": ""
        },
        {
            "name": "detector",
            "baseName": "detector",
            "type": "DetectorType",
            "format": ""
        },
        {
            "name": "resourceReference",
            "baseName": "resourceReference",
            "type": "ResourceReference",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return InfectedExcludePath.attributeTypeMap;
    }
    constructor() {
    }
}
